<template>
	<Col>
		<AppFileUpload
			hide-details
			class="file-input-field"
			:uploadFunc="uploadFunc"
			label="Upload image (20x20)"
			:uploadedFile="uploadedFile"
			accept="image/png, image/jpg"
			@onFileUploaded="onFileUploaded"
			placeholder="Upload image (20x20)"
		/>
	</Col>
</template>
<script>
// import api from '@/api';
// import { mapGetters, mapActions } from 'vuex';
// import { updateWorkflowSetting } from '@/store/modules/selectedWorkflow/actions.js';
// import { getWorkflowAppearanceSettings } from '@/store/modules/selectedWorkflow/getters.js';
export default {
	name: 'NotificationCustomIconUpload',
	components: {},
	props: {},
	computed: {
		uploadedFile() {
			return null;
			// return 'https://freepngimg.com/thumb/tree/8-2-tree-png.png';
		},
	},
	methods: {
		async uploadFunc(file) {
			console.log('uploadFunc  file:', file);
			return 'https://freepngimg.com/thumb/tree/8-2-tree-png.png';
			// const r = await api.updateWorkflowSettingImage(this.workflowAppearanceSettings.id, file, 'background_file');
			// return r.background_file;
		},
		onFileUploaded(payload) {
			console.log('onFileUploaded  payload:', payload);
		},
	},
};
</script>
<style scoped lang="scss">
.file-input-field {
	margin: 0px !important;
	padding: 0px !important;
}
</style>
